import { select2OptionalSchema, select2RequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addClassroomConsultationSchema = object().shape({
    title: stringRequiredSchema,
    school: select2RequiredSchema,
    grade: select2OptionalSchema,
    teacher_id: select2RequiredSchema,

});

export default addClassroomConsultationSchema;